<div class="a11y-modal">

  <!-- Header -->
  <div class="a11y-modal-header">
    <div class="a11y-modal-icon">
      <i class="fa-solid fa-universal-access"></i>
    </div>
    <div>
      <h2 class="a11y-modal-title" translate>Accessibilité</h2>
      <p class="a11y-modal-subtitle" translate>Personnalise ton expérience de lecture</p>
    </div>
    <button class="a11y-close-btn" type="button" (click)="activeModal.dismiss()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="a11y-modal-body">

    <!-- Police dyslexique -->
    <div class="a11y-setting" [class.active]="isDys" (click)="toggleDys()">
      <div class="a11y-setting-icon">
        <i class="fa-solid fa-font"></i>
      </div>
      <div class="a11y-setting-info">
        <span class="a11y-setting-title" translate>Police pour dyslexiques</span>
        <span class="a11y-setting-desc" translate>Active la police OpenDyslexic pour faciliter la lecture</span>
      </div>
      <div class="a11y-toggle" [class.on]="isDys">
        <div class="a11y-toggle-thumb" [class.saving]="saving"></div>
      </div>
    </div>

    <!-- Grossissement du texte -->
    <div class="a11y-setting" [class.active]="isBigFont" (click)="toggleBigFont()">
      <div class="a11y-setting-icon">
        <i class="fa-solid fa-magnifying-glass-plus"></i>
      </div>
      <div class="a11y-setting-info">
        <span class="a11y-setting-title" translate>Grossissement du texte</span>
        <span class="a11y-setting-desc" translate>Agrandit les textes et l'interface pour une meilleure lisibilité</span>
      </div>
      <div class="a11y-toggle" [class.on]="isBigFont">
        <div class="a11y-toggle-thumb" [class.saving]="savingBigFont"></div>
      </div>
    </div>

  </div>

</div>
